module.exports = __webpack_public_path__ + "static/by_nc_nd-a4212c1a42d241a1351fc139b20de70b.png";